// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"62aa9bb0","787":"a96cf5d9"}[chunkId] + ".chunk.js";
};